(() => {
  const path = window.location.pathname || "";
  const isConfirmationPage =
    path.indexOf("/pages/newsletter-confirmation") !== -1 ||
    path.indexOf("/pages/newsletter-bestaetigt") !== -1;

  if (isConfirmationPage) {
    document.documentElement.classList.add("newsletter-confirmation-pending");
    window.setTimeout(() => {
      document.documentElement.classList.remove(
        "newsletter-confirmation-pending"
      );
      document.documentElement.classList.add("newsletter-confirmation-ready");
    }, 1000);
  }

})();
